module.exports = __webpack_public_path__ + "img/bx-empty-webhook.3fc7f199.png";